import { fromJS } from "immutable";
import * as actionTypes from './actionTypes';

const initialState = fromJS({
  investmentUST: {
    isLoading: true,
    data: [],
    error: ""
  },
  myInvestmentUST: {
    isLoading: true,
    data: [],
    error: ""
  },
  investmentDrupal: {
    isLoading: true,
    data: [],
    error: ""
  },
  underlyingDrupal: {
    isLoading: true,
    data: [],
    error: ""
  },
  tableData: {
    isLoading: true,
    data: {},
    error: ""
  },
  quaterlyReport: {
    isLoading: true,
    data: [],
    error: ""
  },
  processed:{
    data:null,
    error:""
  }
});

const investmentOptionDetail = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.investmentOptionUstDataType:
      return state
        .setIn(["investmentUST", "data"], action.payload)
        .setIn(["investmentUST", "isLoading"], false);
    case actionTypes.investmentOptionUstDataLoaderType:
      return state.setIn(["investmentUST", "isLoading"], true);

    case actionTypes.myInvestmentOptionUstDataType:
      return state
        .setIn(["myInvestmentUST", "data"], action.payload)
        .setIn(["myInvestmentUST", "isLoading"], false);
    case actionTypes.myInvestmentOptionUstDataLoaderType:
      return state.setIn(["myInvestmentUST", "isLoading"], true);

    case actionTypes.investmentOptionDrupalDataType:
      return state
        .setIn(["investmentDrupal", "data"], action.payload)
        .setIn(["investmentDrupal", "isLoading"], false);
    case actionTypes.investmentOptionDrupalDataLoaderType:
      return state.setIn(["investmentDrupal", "isLoading"], true);

    case actionTypes.underlyingOptionDrupalDataType:
      return state
        .setIn(["underlyingDrupal", "data"], action.payload)
        .setIn(["underlyingDrupal", "isLoading"], false);
    case actionTypes.underlyingOptionDrupalDataLoaderType:
      return state.setIn(["underlyingDrupal", "isLoading"], true);

    case actionTypes.fetchUnderlyingTableDataSuccessType:
      return state
        .setIn(["tableData", "data"], action.payload)
        .setIn(
          ["tableData", "isLoading"],
          !state.getIn(["tableData", "isLoading"])
        );

    case actionTypes.quaterlyReportDrupalDataType:
      return state
        .setIn(["quaterlyReport", "data"], action.payload)
        .setIn(["quaterlyReport", "isLoading"], false);
    case actionTypes.quaterlyReportDrupalDataLoaderType:
      return state.setIn(["quaterlyReport", "isLoading"], true);
    case actionTypes.processedDataType:
        return state.setIn(["processed", "data"], action.payload);

    default:
      return state;
  }
};

export default investmentOptionDetail;
